<template>
  <div
    class="c-select"
    :class="{
      'c-select_reverse': reverse !== undefined,
    }"
  >
    <div class="c-select__wrapper">
      <div v-if="label" class="c-select__label">{{ label }}</div>

      <div
        class="c-select__select"
        :class="{ 'c-select__select-required': Array.isArray(valueLocal) && valueLocal.length === 0 && required }"
      >
        <v-select
          v-model="valueLocal"
          :components="components"
          :options="items"
          :clearable="clearable !== undefined"
          :searchable="searchable !== undefined"
          :placeholder="placeholder"
          :multiple="multiple !== undefined"
        >
          <template #no-options="{ searching }">
            <template v-if="searching"> Совпадений не найдено </template>
          </template>

          <template v-if="required !== undefined" #footer>
            <div
              class="notice"
              :class="{
                notice_hidden: multiple !== undefined ? valueLocal.length !== 0 : valueLocal !== null,
              }"
            >
              <div class="notice__icon">
                <c-icon icon="notice" />
              </div>

              <div class="notice__text">{{ required }}</div>
            </div>
          </template>

          <template #option="option">
            <div
              class="c-select__option"
              :class="{
                'c-select__option_selected': value ? isSelected(option.value) : false,
                'c-select__option_avatar': option.avatar,
              }"
            >
              <div
                v-if="option.avatar"
                class="c-select__option-avatar"
                :style="{ 'background-image': `url(${option.avatar})` }"
              ></div>

              <div class="c-select__option-label">{{ option.label }}</div>
            </div>
          </template>
        </v-select>
      </div>

      <div v-if="reverse !== undefined && multiple !== undefined" class="c-select__reverse">
        <c-switcher v-model="reverseLocal" label="Все кроме" type="checkbox" :disabled="valueLocal.length === 0" />
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Deselect from "./select/deselect";
import OpenIndicator from "./select/openindicator";
import Icon from "@/components/icon";
import Switcher from "@/components/controls/switcher";

export default {
  name: "c-select",

  components: {
    "v-select": vSelect,
    "c-icon": Icon,
    "c-switcher": Switcher,
  },

  props: [
    "label",
    "items",
    "placeholder",
    "value",
    "size",
    "multiple",
    "clearable",
    "searchable",
    "required",
    "reverse",
  ],

  data() {
    return {
      components: {
        Deselect,
        OpenIndicator,
      },
      valueLocal: this.value,
      reverseLocal: this.reverse,
    };
  },

  watch: {
    value(value) {
      this.valueLocal = value;
    },

    valueLocal(value) {
      if (this.multiple !== undefined && value.length === 0) {
        this.reverseValueLocal = false;
      }

      this.$emit("input", value);
    },

    reverse(value) {
      this.reverseLocal = value;
    },

    reverseLocal(value) {
      this.$emit("changeReverse", value);
    },
  },

  methods: {
    isSelected(value) {
      if (this.multiple !== undefined) {
        const ar = this.valueLocal.map((item) => item.value);

        return ar.includes(value);
      }
      return value === this.valueLocal.value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-select {
  position: relative;
  width: 100%;

  &__label {
    font: {
      size: 12px;
    }
    line-height: 13px;
    margin-bottom: 10px;
    color: $color-label;
  }

  &__option {
    padding: 5px 14px;
    border-radius: 15px;
    display: flex;
    align-items: center;

    &:hover {
      background: $color-bg-hover;
    }

    &_selected {
      color: $color-label;
      cursor: default;

      &:hover {
        background: white !important;
      }
    }

    &_avatar {
      border-radius: 50px;
    }

    &-avatar {
      width: 34px;
      height: 34px;
      background-size: cover;
      background-position: center;
      border-radius: 50%;
      margin-right: 10px;
    }
  }

  .notice {
    margin-top: 8px;
    transition: 0.2s;

    &_hidden {
      margin-top: -20px;
      visibility: hidden;
      opacity: 0;
    }
  }

  &__reverse {
    position: absolute;
    right: 0;
    bottom: 5px;
    z-index: 100;
  }
}
</style>
